/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AdminAgentBorrowingRange model module.
 * @module model/AdminAgentBorrowingRange
 * @version 1.0.0
 */
class AdminAgentBorrowingRange {
    /**
     * Constructs a new <code>AdminAgentBorrowingRange</code>.
     * @alias module:model/AdminAgentBorrowingRange
     */
    constructor() { 
        
        AdminAgentBorrowingRange.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AdminAgentBorrowingRange</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AdminAgentBorrowingRange} obj Optional instance to populate.
     * @return {module:model/AdminAgentBorrowingRange} The populated <code>AdminAgentBorrowingRange</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AdminAgentBorrowingRange();

            if (data.hasOwnProperty('annual_income_min')) {
                obj['annual_income_min'] = ApiClient.convertToType(data['annual_income_min'], 'Number');
            }
            if (data.hasOwnProperty('annual_income_max')) {
                obj['annual_income_max'] = ApiClient.convertToType(data['annual_income_max'], 'Number');
            }
            if (data.hasOwnProperty('multiplier')) {
                obj['multiplier'] = ApiClient.convertToType(data['multiplier'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AdminAgentBorrowingRange</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AdminAgentBorrowingRange</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} annual_income_min
 */
AdminAgentBorrowingRange.prototype['annual_income_min'] = undefined;

/**
 * @member {Number} annual_income_max
 */
AdminAgentBorrowingRange.prototype['annual_income_max'] = undefined;

/**
 * @member {Number} multiplier
 */
AdminAgentBorrowingRange.prototype['multiplier'] = undefined;






export default AdminAgentBorrowingRange;

